import React, { useRef } from 'react'

import { css, cx } from '@emotion/css'

import './insight.min.css'

import Select, { components } from 'react-select'

import { getKeepers, buildOptionSubtitle } from './searchHelpers'

const Searcher = ({ setOccupation, occupations }) => {
  let options = Object.values(occupations).map(suggestion => {
    suggestion.value = suggestion.title
    suggestion.label = suggestion.title
    suggestion.isDisabled = suggestion.noData
    return suggestion
  })

  let keepers = useRef({
    lastFilteredOn: '',
    filtered: getKeepers(options, '')
  })

  return (
    <Select
      escapeClearsValue
      isClearable
      defaultValue={options[0]}
      styles={
        {
          option: () => ({}),
          singleValue: (original) => ({ ...original, color: 'white' }),
          input: (original) => ({ ...original, color: 'white' }),
          control: (original) => ({ ...original, color: 'white', backgroundColor: '#1d1f21' }),
          menu: () => ({ border: '1px solid #aaa', borderRadius: '5px', backgroundColor: '#1d1f21' })
        }
      }
      components={{
        Option
      }}
      filterOption={({ data }, string) => {
        if (keepers.current.lastFilteredOn !== string) {
          keepers.current.filtered = getKeepers(options, string)
          keepers.current.lastFilteredOn = string
        }
        return keepers.current.filtered[data.title]
      }}
      options={options}
      onChange={(option, { action }) => {
        if (action === 'select-option') {
          setOccupation(option)
        }
      }}
    />
  )
}

export default Searcher

const Option = ({ children, ...props }) => {
  const { onMouseMove, onMouseOver, ...rest } = props.innerProps
  const newProps = Object.assign(props, { innerProps: rest })

  const { data: option } = newProps

  let prefix = ''
  if (option.noData) {
    prefix = '[no data]'
  } else if (option.missingData) {
    prefix = '[incomplete data]'
  }

  let subtitle = buildOptionSubtitle(option)

  return (
    <components.Option
      {...newProps}
      className={cx(
        css`
          cursor: default;
          display: block;
          padding: 8px 12px;
          width: 100%;
          user-select: none;
          box-sizing: border-box;

          padding-left: ${option.depth * 20}px;

          ${newProps.isDisabled ? css`
            opacity: .5;
          ` : ''}

          ${newProps.isSelected ? css`
            background-color: #2684FF;
          ` : ''}

          ${newProps.isFocused ? css`
            background-color: rgba(255,255,255,.25);
          ` : ''}

          :hover {
            background-color: rgba(255,255,255,.25)
          }
        `,
        {
          option: true,
          'option--is-disabled': newProps.isDisabled,
          'option--is-focused': newProps.isFocused,
          'option--is-selected': newProps.isSelected
        }
      )}
    >
      {option.noData && (
        <div>
          <span className={css``}>{prefix} </span>
          <span className={css`text-decoration: line-through;`}>{option.title}</span>
        </div>
      )}
      {option.missingData && (
        <div>
          <span className={css``}>{prefix} </span>
          <span>{option.title}</span>
        </div>
      )}
      {(!option.noData && !option.missingData) && (
        <div>{option.title}</div>
      )}
      <div
        className={css`
        font-style: italic;
        font-size: 14px;
      `}
      >
        {subtitle.join(' | ')}
      </div>
    </components.Option>
  )
}
